/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prettier/prettier */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
import React, { useRef, useState, useCallback, useEffect } from 'react';
import { Form } from '@unform/web';
import { useParams, useHistory, Link } from 'react-router-dom';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { FormHandles } from '@unform/core';
import { IoCartOutline } from 'react-icons/io5';
import ConverArrayBufferToData from '../../utils/ConverArrayBufferToData';
import RechargeService from '../../services/recharge';
import { formatPrice } from '../../utils/currencyFormater';
import {
  RechargeTicketOrderData,
  ConfirmRechargeTicketData,
} from '../../interfaces/recharge';
import DownLoadFile from '../../utils/DownLoadFile';
import Loader from '../../components/Loader';
import InputCurrency from '../../components/InputCurrency';
import Button from '../../components/Button';
import ConfirmationModal from '../../components/ConfirmationModal';
import { useToast } from '../../hooks/toast';
import LoaderModal from '../../components/LoaderModal';
import EmployeeTable from './components/EmployeeTable';
import DepartamentosService, {
  Departamento,
} from '../../services/departamentos';
import {
  Row,
  Column,
  IconContainer,
} from '../../styles/components';
import {
  Container,
  Title,
  SubTitle,
  Card,
  DataContainer,
  DataContainerRecharge,
  ButtonInitial,
  StatusRow,
  ButtonsContainer,
  ServicedEmployees,
} from './styles';

interface DetailParams {
  CodigoPedido: string;
}

const RechargeOrderDetail: React.FC = () => {
  const TableFormRef: any = useRef<FormHandles>(null);
  const { CodigoPedido } = useParams<DetailParams>();
  const service = { RechargeService: new RechargeService() };
  const serviceDepto = { DepartamentosService: new DepartamentosService() };
  const [departamentos, setDepartamentos] = useState<Departamento[]>(
    [] as Departamento[],
  );
  console.log({ departamentos });
  const { addToast } = useToast();
  const { goBack } = useHistory();
  const [page, setpage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  console.log({
    page,
    perPage,
  });
  const [totalRows] = useState<number>(0);
  const [tableLoader] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(true);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [employeesRechargeOrder, setEmployeesRechargeOrders] = useState<any>(
    [],
  );
  const [rechargeOrder, setRechargeOrder] = useState<RechargeTicketOrderData>(
    {} as RechargeTicketOrderData,
  );
  const [showRemoveRechargeOrder, setShowRemoveRechargeOrder] =
    useState<boolean>(false);

  const [showConfirmRechargeOrder, setShowConfirmRechargeOrder] =
    useState<boolean>(false);

  const [showCancelRechargeOrder, setShowCancelRechargeOrder] =
    useState<boolean>(false);

  const [cardPedido, setCardPedido] = useState('');
  const [valorPedido, setValorPedido] = useState('');

  const getEmployeesRechargeOrders = useCallback(async () => {
    const responseDepartamento =
      await serviceDepto.DepartamentosService.getDepartamentos();
    await setDepartamentos(responseDepartamento.data.DepartamentoLista);

    await setRechargeOrder({} as RechargeTicketOrderData);
    setLoader(true);
    const response = await service.RechargeService.getEmployeesRechargeOrder(
      { filters: [{ order_code: CodigoPedido }] },
      CodigoPedido,
    );
    const results = response.data.ListaItemDeRecarga.map((a: any) => {
      const abc = responseDepartamento.data.DepartamentoLista.filter(
        (f: any) => {
          return f.CodigoDepartamento === a.CodDepartamento;
        },
      )[0];
      return { ...a, departamento: abc };
    });
    setRechargeOrder(response.data.DadosDoPedidoDeRecarga);
    const sorted = results.sort((x: any, y: any) => {
      const a = x.NomeFuncionario.toUpperCase();
      const b = y.NomeFuncionario.toUpperCase();
      return a === b ? 0 : a > b ? 1 : -1;
    });
    setEmployeesRechargeOrders(sorted);
    setLoader(false);
  }, []);

  console.log(employeesRechargeOrder);

  const getStatusText = useCallback((status: any) => {
    const statusOptions: any = {
      C: 'A PAGAR',
      F: 'FINALIZADO',
      E: 'EM ANDAMENTO',
      B: 'A PAGAR',
      P: 'PAGO',
    };
    return statusOptions[status];
  }, []);

  const handleCreateBillet = useCallback(async (data: any) => {
    try {
      setLoadingModal(true);
      const response = await service.RechargeService.getRechargeBillet(
        String(data.Codigo),
      );

      DownLoadFile(response.data, `boletoPedido${data.Codigo}.pdf`);
      setLoadingModal(false);
    } catch (err: any) {
      setLoadingModal(false);
      const { ...error } = err;
      if (error.response.status === 500) {
        addToast({
          type: 'error',
          title: 'Error Interno do Servidor',
          description: 'Contate a administração do site para reportar o erro',
        });
      }
    }
  }, []);

  const handleCreateReceipt = useCallback(async (data: any) => {
    try {
      setLoadingModal(true);
      const response = await service.RechargeService.getRechargeReceipt(
        String(data.Codigo),
      );
      DownLoadFile(response.data, `ReciboPedido${data.Codigo}.pdf`);
      setLoadingModal(false);
    } catch (err: any) {
      setLoadingModal(false);

      const { ...error } = err;
      const errorResponse = ConverArrayBufferToData(error.response.data);

      if (errorResponse.Summary.ErrorCollection.SystemFailureErros.length) {
        addToast({
          type: 'error',
          title: `${errorResponse.Summary.ErrorCollection.SystemFailureErros[0].ErrorMessage}`,
          description: `${errorResponse.Summary.ErrorCollection.SystemFailureErros[0].InternalErrorMessage}`,
        });
      }
    }
  }, []);

  const handleRemoveRechargeOrder = useCallback(async (data: any) => {
    try {
      await service.RechargeService.removeRechargeOrder(String(data.Codigo));
      addToast({
        type: 'success',
        title: 'Sucesso',
        description: 'Pedido Removido!!',
      });
      goBack();
    } catch (err: any) {
      const { ...error } = err;
      console.error(error);
    }
  }, []);

  const handleConfirmRechargeOrder = useCallback(
    async (data: ConfirmRechargeTicketData) => {
      try {
        const valor = parseFloat(rechargeOrder.Valor);

        if (valor > 0) {
          await service.RechargeService.confirmRechargeOrder(data);
          addToast({
            type: 'success',
            title: 'Sucesso',
            description: 'Pedido Finalizado!!',
          });
          getEmployeesRechargeOrders();
        } else {
          addToast({
            type: 'info',
            title: 'Atenção',
            description: 'O valor do pedido deverá ser maior do R$ 0,00',
          });
        }
      } catch (err: any) {
        const { ...error } = err;
        console.error(error);
      }
    },
    [rechargeOrder],
  );

  const handleCancelRechargeOrder = useCallback(async (data: any) => {
    try {
      await service.RechargeService.cancelRechargeOrder(String(data.Codigo));

      addToast({
        type: 'success',
        title: 'Sucesso',
        description: 'Pedido cancelado!!',
      });
    } catch (err: any) {
      const { ...error } = err;
      console.error(error);
    }
  }, []);

  const handleChangePerPage = useCallback(async (newPage: number) => {
    setpage(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback(
    async (newPerPage: number, OldPerPage: number) => {
      setPerPage(newPerPage);
      setpage(OldPerPage);
    },
    [],
  );

  const handleSave = useCallback(async (item: any) => {
    const data = TableFormRef?.current?.getData();

    if (data) {
      const postData = {
        CodigoPedido,
        ListaItensPedidoRegarga: [
          {
            IdentificadorCartaoVT: item.IdentificadorCartaoVt,
            Valor: String(data[item.IdentificadorCartaoVt]),
          },
        ],
      };
      try {
        setLoadingModal(true);
        await service.RechargeService.updateEmployeesRechargeOrder(postData);

        addToast({
          type: 'success',
          title: 'Sucesso',
          description: 'Valor da carga editado com sucesso!!',
        });
        setLoadingModal(false);
        getEmployeesRechargeOrders();
      } catch (err: any) {
        setLoadingModal(false);
        const { ...error } = err;

        addToast({
          type: 'error',
          title: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].ErrorMessage}`,
          description: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].InternalErrorMessage}`,
        });
      }
    }
  }, []);

  const handleSaveAll = useCallback(async () => {
    try {
      setLoadingModal(true);
      const data = TableFormRef?.current?.getData();
      const newdata = Object.entries(data).map(([key, value]:any) => {
        const result = {
          IdentificadorCartaoVT: key,
          Valor: String(value),
        };
        return result;
      });

      const postData = {
        CodigoPedido,
        ListaItensPedidoRegarga: newdata,
      };
      await service.RechargeService.updateEmployeesRechargeOrder(postData);

      addToast({
        type: 'success',
        title: 'Sucesso',
        description: 'Valor da carga editado com sucesso!!',
      });
      setLoadingModal(false);
      getEmployeesRechargeOrders();
    } catch (err: any) {
      setLoadingModal(false);
      const { ...error } = err;
      console.log(err);
      addToast({
        type: 'error',
        title: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].ErrorMessage}`,
        description: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].InternalErrorMessage}`,
      });
    }
  }, []);

  useEffect(() => {
    getEmployeesRechargeOrders();
  }, []);

  return (
    <Container>
      {loader ? (
        <Loader />
      ) : (
        <>
          {!!Object.keys(rechargeOrder).length && (
            <>
              <Row className="titleWrapper">
                <Column small="2" medium="2" large="2">
                  <IconContainer align="center">
                    <IoCartOutline />
                  </IconContainer>
                </Column>
                <Column
                  small="10"
                  medium="10"
                  large="10"
                  className="TitleContainer"
                >
                  <Title>
                    <h1 className="title">
                      {`Pedido de Recarga ${CodigoPedido}`}
                    </h1>
                    <Link to="/pedidos-de-recarga">
                      <AiOutlineArrowLeft
                        size={30}
                        style={{ color: '#3F1159' }}
                      />
                    </Link>
                  </Title>
                </Column>
              </Row>
              <Column small="12" medium="12" large="12">
                <ButtonsContainer>
                  {rechargeOrder.Status === 'E' && (
                    <ButtonInitial>
                      <Button
                        color="purple"
                        className="pedido"
                        padding="1"
                        type="button"
                        onClick={() => setShowConfirmRechargeOrder(true)}
                      >
                        FINALIZAR PEDIDO
                      </Button>
                    </ButtonInitial>
                  )}
                  {rechargeOrder.Status === 'C' && (
                    <ButtonInitial>
                      <Button
                        color="purple"
                        className="boleto"
                        padding="1"
                        type="button"
                        onClick={() => handleCreateBillet(rechargeOrder)}
                      >
                        EMITIR BOLETO
                      </Button>
                    </ButtonInitial>
                  )}
                  {rechargeOrder.Status === 'B' && (
                    <ButtonInitial>
                      <Button
                        color="purple"
                        className="boleto"
                        padding="1"
                        type="button"
                        onClick={() => handleCreateBillet(rechargeOrder)}
                      >
                        EMITIR BOLETO
                      </Button>
                    </ButtonInitial>
                  )}
                  {rechargeOrder.Status === 'F' && (
                    <ButtonInitial>
                      <Button
                        color="purple"
                        className="boleto"
                        padding="1"
                        type="button"
                        onClick={() => handleCreateReceipt(rechargeOrder)}
                      >
                        EMITIR RECIBO
                      </Button>
                    </ButtonInitial>
                  )}
                  {rechargeOrder.Status === 'P' && (
                    <ButtonInitial>
                      <Button
                        color="purple"
                        className="boleto"
                        padding="1"
                        type="button"
                        onClick={() => handleCreateReceipt(rechargeOrder)}
                      >
                        EMITIR RECIBO
                      </Button>
                    </ButtonInitial>
                  )}
                  {rechargeOrder.Status === 'E' && (
                    <ButtonInitial>
                      <Button
                        color="white"
                        className="remove"
                        padding="1"
                        type="button"
                        onClick={() => setShowRemoveRechargeOrder(true)}
                      >
                        REMOVER PEDIDO
                      </Button>
                    </ButtonInitial>
                  )}
                  {rechargeOrder.Status === 'C' && (
                    <ButtonInitial>
                      <Button
                        color="white"
                        className="remove"
                        padding="1"
                        type="button"
                        onClick={() => setShowCancelRechargeOrder(true)}
                      >
                        CANCELAR PEDIDO
                      </Button>
                    </ButtonInitial>
                  )}
                </ButtonsContainer>
              </Column>
              <DataContainer>
                <Column small="12" medium="12" large="12">
                  <Card>
                    <DataContainerRecharge>
                      <Row>
                        <Column small="12" medium="6" large="6">
                          <SubTitle>Código de Recarga</SubTitle>
                          <h1>{rechargeOrder.Codigo}</h1>
                        </Column>
                        <Column small="12" medium="6" large="6">
                          <SubTitle>Data do Pedido</SubTitle>
                          <div style={{ color: '#3F1159' }}>
                            {rechargeOrder.Data}
                          </div>
                        </Column>
                        <Column small="12" medium="6" large="6">
                          <SubTitle>Status</SubTitle>
                          {rechargeOrder.Status && (
                            <StatusRow
                              status={
                                rechargeOrder.Status === 'C'
                                  ? 'C'
                                  : rechargeOrder.Status === 'F'
                                  ? 'F'
                                  : rechargeOrder.Status === 'E'
                                  ? 'E'
                                  : rechargeOrder.Status === 'B'
                                  ? 'B'
                                  : rechargeOrder.Status === 'P'
                                  ? 'P'
                                  : 'C'
                              }
                            >
                              {getStatusText(rechargeOrder.Status)}
                            </StatusRow>
                          )}
                        </Column>
                        <Column small="12" medium="6" large="6">
                          <SubTitle>Valor do Pedido</SubTitle>
                          <h2>{`R$${rechargeOrder.Valor}`}</h2>
                        </Column>
                      </Row>
                    </DataContainerRecharge>
                  </Card>
                </Column>
              </DataContainer>
              <Row>
                <Column small="12" medium="12" large="12">
                  <ServicedEmployees>
                    <Title>
                      Funcionários Atendidos
                      <Button
                        color="green"
                        className="saveall"
                        padding="1"
                        type="button"
                        onClick={handleSaveAll}
                      >
                        SALVAR TODOS
                      </Button>
                    </Title>
                    <Form ref={TableFormRef} onSubmit={handleSave}>
                      <EmployeeTable
                        data={employeesRechargeOrder}
                        columns={[
                          {
                            name: 'Funcionário',
                            selector: 'NomeFuncionario',
                            maxWidth: '165px',
                            sortable: true,
                            cell: ({ CodigoFuncionario, NomeFuncionario }: any) => (
                              <Link
                                to={`/funcionarios/${CodigoFuncionario}`}
                                style={{
                                  textDecoration: 'underline',
                                  textUnderlinePosition: 'under',
                                  color: '#3F1159',
                                }}
                                target="blank"
                              >
                                {`${NomeFuncionario}`}
                              </Link>
                            ),
                          },
                          {
                            name: 'Matrícula',
                            selector: 'MatriculaFuncionario',
                            maxWidth: '10px',
                            sortable: true,
                          },
                          {
                            name: 'Cartão VT',
                            selector: 'IdentificadorCartaoVt',
                            maxWidth: '145px',
                            sortable: true,
                            cell: ({ IdentificadorCartaoVt }: any) => (
                              <Link
                                to={`/cartoes/${IdentificadorCartaoVt}`}
                                style={{
                                  textDecoration: 'underline',
                                  textUnderlinePosition: 'under',
                                  color: '#3F1159',
                                }}
                                target="blank"
                              >
                                {`${IdentificadorCartaoVt}`}
                              </Link>
                            ),
                          },
                          {
                            name: 'Departamento',
                            selector: 'departamento',
                            maxWidth: '114px',
                            cell: ({ departamento }: any) => (
                              <p>
                                {departamento?.Nome}
                                {!departamento?.Nome && <span>--</span>}
                              </p>
                            ),
                          },
                          {
                            name: 'Núm. dias',
                            selector: 'NumeroDeDiasDaCarga',
                            maxWidth: '10px',
                          },
                          {
                            name: 'Valor da carga',
                            selector: 'ValorCarga',
                            maxWidth: '25000px',
                            id: 'valorcarga',
                            cell: (row: any) => {
                              const { ValorCarga, IdentificadorCartaoVt } = row;
                              console.log(ValorCarga);
                              if (rechargeOrder.Status === 'E') {
                                return (
                                  <div className="inputContainer">
                                    <InputCurrency
                                      className="input"
                                      name={IdentificadorCartaoVt}
                                      placeholder="Digite o valor"
                                      defaultValue={ValorCarga}
                                      value={ValorCarga}
                                    />
                                    <button
                                      type="button"
                                      onClick={() => handleSave({ IdentificadorCartaoVt })}
                                    >
                                      Salvar
                                    </button>
                                  </div>
                                );
                              }
                              return (
                                <div>{formatPrice(ValorCarga)}</div>
                              );
                            },
                          },
                        ]}
                        emptyText="Nenhum Funcionário atendido"
                        loading={tableLoader}
                        totalRows={totalRows}
                        onChangePage={handleChangePerPage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                      />
                    </Form>
                  </ServicedEmployees>
                </Column>
              </Row>
            </>
          )}
        </>
      )}
      {showRemoveRechargeOrder && (
        <ConfirmationModal
          title="Remoção de pedido de recarga"
          text="Tem certeza que você deseja Remover este Pedido de Recarga?"
          show={showRemoveRechargeOrder}
          handleClose={() => setShowRemoveRechargeOrder(false)}
          handleSuccess={() => handleRemoveRechargeOrder(rechargeOrder)}
        />
      )}
      {showConfirmRechargeOrder && (
        <ConfirmationModal
          title="Finalização do pedido"
          text="Deseja finalizar esse pedido?"
          show={showConfirmRechargeOrder}
          handleClose={() => setShowConfirmRechargeOrder(false)}
          handleSuccess={() =>
            handleConfirmRechargeOrder({
              CodigoPedido: String(rechargeOrder.Codigo),
              TipoPagamento: '1',
            })
          }
        />
      )}
      {showCancelRechargeOrder && (
        <ConfirmationModal
          title="Cancelamento de pedido"
          text="tem certeza que deseja cancelar esse pedido?"
          show={showCancelRechargeOrder}
          handleClose={() => setShowCancelRechargeOrder(false)}
          handleSuccess={() => handleCancelRechargeOrder(rechargeOrder)}
        />
      )}
      {loadingModal && (
        <LoaderModal
          title="Carregando"
          show={loadingModal}
          handleClose={() => setLoadingModal(false)}
        />
      )}
    </Container>
  );
};

export default RechargeOrderDetail;
